import {RouteRecordRaw} from "vue-router";
import CommunicationCustomerView from "@/communication/views/CommunicationCustomerView.vue";
import CommunicationMessagePushView from "@/communication/views/CommunicationMessagePushView.vue";
import CommunicationSummaryView from "@/communication/views/CommunicationSummaryView.vue";
import CommunicationMessageStoreView from "@/communication/views/CommunicationMessageStoreView.vue";
import CommunicationMessageSMSView from "@/communication/views/CommunicationMessageSMSView.vue";
import CommunicationSMSBatchView from "@/communication/views/CommunicationSMSBatchView.vue";
import CommunicationView from "@/communication/views/CommunicationView.vue";
import CommunicationProgramsView from "@/communication/views/CommunicationProgramsView.vue";
import CommunicationSequencesView from "@/communication/views/CommunicationSequencesView.vue";
import CommunicationConversationMessagesView from "@/communication/views/CommunicationConversationMessagesView.vue";
import ProgramNotificationSequence from "@/program/views/ProgramNotificationSequence.vue";

const routes: RouteRecordRaw[] = [
    {
        path: 'communication',
        name: 'patient-administration.communication',
        component: CommunicationView
    },
    {
        path: 'communication/customers',
        name: 'patient-administration.communication.customers',
        component: CommunicationCustomerView
    },
    {
        path: 'communication/programs',
        name: 'patient-administration.communication.programs',
        component: CommunicationProgramsView
    },
    {
        path: 'communication/sequences',
        name: 'patient-administration.communication.sequences',
        component: CommunicationSequencesView
    },
    {
        path: 'communication/sequences/:sequenceId',
        name: 'patient-administration.communication.sequences.details',
        component: ProgramNotificationSequence,
        props: true
    },
    {
        path: 'communication/conversation-messages',
        name: 'patient-administration.communication.conversation-messages',
        component: CommunicationConversationMessagesView
    },
    {
        path: 'communication/message/notification',
        name: 'patient-administration.communication.message.notification',
        component: CommunicationMessagePushView,
    },
    {
        path: 'communication/message/sms',
        name: 'patient-administration.communication.message.sms',
        component: CommunicationMessageSMSView,
    },
    {
        path: 'communication/summary',
        name: 'patient-administration.communication.summary',
        component: CommunicationSummaryView
    },
    {
        path: 'communication/message/store',
        name: 'patient-administration.communication.message.store',
        component: CommunicationMessageStoreView
    },
    {
        path: 'communication/message/history',
        name: 'patient-administration.communication.message.history',
        redirect: {
            name: 'patient-administration.communication.conversation-messages',
            query: {tab: 'batches'}
        }
    },
    {
        path: 'communication/message/batch/:batchId',
        name: 'patient-administration.communication.message.batch',
        component: CommunicationSMSBatchView,
        props: true
    }
];

export default routes;
